<!-- Discussion List-->
<div class="row">
  <div class="col-12 notification-list">
    <div [hidden]="loading">
      <h6>
        <span *ngIf="results.length > 0">
          {{ results.length }} of {{ totalCount }}
        </span>
        Notifications
        <label *ngIf="results.length > 0" class="label label-danger">new</label>
      </h6>

      <general-notification-preview
        style="margin: 0px; padding: 0px"
        *ngFor="let notification of results"
        [notification]="notification"
        [config]="config"
        [currentUser]="currentUser"
        (updateNotifications)="updateNotifications($event)"
      >
      </general-notification-preview>
    </div>

    <!-- Loader spinner -->
    <loader-animation [loading]="loading" [message]="'Loading notifications'">
    </loader-animation>
    <!-- Loader spinner -->

    <!-- No content message-->
    <no-content-msg
      [hidden]="loading || results.length"
      [message]="'No new notifications'"
    >
    </no-content-msg>
    <!-- No content message -->

    <!-- Pagination -->
    <pagination-buttons
      [currentPage]="currentPage"
      [loading]="loading"
      [showNavBar]="false"
      [smallButtons]="false"
      [totalPageCount]="totalPages"
      (setPageTo)="setPageTo($event)"
    >
    </pagination-buttons>
    <!-- Pagination -->
  </div>
</div>
